import loginConstants from '../constants/LoginConstants';
import { loginUser, getUserByUsernameDepth } from '../shared/requests/UserRequests';

// action creators
function request() {
  return {
    type: loginConstants.LOGIN_REQUEST,
  };
}
function success(token, user) { // used to set user data for lack of better system
  return {
    type: loginConstants.LOGIN_SUCCESS,
    token,
    user,
  };
}
function failure(error) {
  return {
    type: loginConstants.LOGIN_FAILURE,
    error,
  };
}

function userLoginRequest(username, password) {
  return function action(dispatch) {
    // begin request
    dispatch(request());
    loginUser(username, password)
      .then((response) => {
        // token received, get user data
        getUserByUsernameDepth(username)
          .then((secondResponse) => {
            dispatch(success(response.data.access_token, secondResponse.data));
          }).catch((secondError) => {
            // user data unavailable, this shouldn't happen
            dispatch(failure(secondError.response));
          });
      }).catch((error) => {
        // login failure
        dispatch(failure(error.response));
      });
  };
}

function verifyEmail(isVerified) {
  return {
    type: loginConstants.EMAIL_VERIFIED,
    payload: isVerified,
  };
}

function userMasqueradeRequest(username, token) {
  return function action(dispatch) {
    dispatch(request());
    getUserByUsernameDepth(username)
      .then((response) => {
        dispatch(success(token, response.data));
      }).catch((error) => {
        // user data unavailable, this shouldn't happen
        dispatch(failure(error.response));
      });
  };
}

export {
  userLoginRequest,
  userMasqueradeRequest,
  verifyEmail,
  success,
};
